import { Condition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type ExchangeCountState = string;

export const EXCHANGE_COUNT = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ExchangeCountState>>,
): ConditionType<ExchangeCountState, Condition.ExchangeCount> => ({
  name: "Number of exchanges",
  description(state) {
    switch (state) {
      case undefined:
        return "The number of times the customer has exchanged a specific item. This condition is true only if every item has this many previous exchanges. For example: If the customer returns item 'x' for the same item, and also adds a new item 'y' to the exchange order, and then does a return on the exchange order for item 'x' and 'y', this condition will be false if you have previous exchanges as 1 since item 'y' was not previously exchanged. It would be true if only 'x' was being returned for the exchange order.";
      case "1":
        return "No previous exchanges";
      case "2":
        return "Maximum 1 previous exchange";
      default:
        return `Maximum ${+state - 1} previous exchanges`;
    }
  },
  Details(props: ConditionTypeDetailsProps<ExchangeCountState>) {
    return React.createElement(Details, props);
  },
  empty: (1).toFixed(0),
  fromModel(model) {
    return model.numExchanges.toFixed(0);
  },
  toModel(state) {
    return { type: Condition.EXCHANGE_COUNT, numExchanges: +state };
  },
  valid(state) {
    return +state >= 1 && +state % 1 === 0; // Must be whole number
  },
});
